import instance from "./instance";
import { ENV } from "@/constants/env";
import {
  ChatPromptDto,
  CreateChatPromptDto,
  UpdateChatPromptDto,
  ChatPromptListRequestDto,
} from "@/dto/ChatPromptDto";
import { ResultListDto } from "@/dto/ResponseDto";

const PREFIX_PATH = `${ENV.PRE_FIX}/${ENV.ADMIN_PATH}`;

export const superChatPromptApi = {
  /**
   * 프롬프트 목록 조회
   */
  async getList(
    params: ChatPromptListRequestDto = {}
  ): Promise<ResultListDto<ChatPromptDto>> {
    const apiUrl = `${PREFIX_PATH}/qna-prompt`;

    console.log("[API_CALL]", {
      url: apiUrl,
      method: "GET",
      params,
      PREFIX_PATH,
      baseURL: ENV.API_URL,
    });

    const response = await instance.get(apiUrl, { params });

    console.log("[API_RESPONSE]", {
      url: apiUrl,
      dataStructure: response ? Object.keys(response) : "null/undefined",
      dataCount: response?.list?.length || 0,
      fullResponse: response,
      hasData: !!response,
    });

    // 응답 데이터 검증 (인터셉터에서 이미 response.data를 반환함)
    if (!response) {
      console.error("[API_ERROR]", "Response is null or undefined");
      throw new Error("No data received from server");
    }

    // 인터셉터에서 이미 response.data를 반환하므로 직접 사용
    return response;
  },

  /**
   * 프롬프트 상세 조회
   */
  async getDetail(id: number): Promise<ChatPromptDto> {
    const apiUrl = `${PREFIX_PATH}/qna-prompt/${id}`;

    console.log("[API_CALL]", {
      url: apiUrl,
      method: "GET",
      id,
    });

    const response = await instance.get(apiUrl);

    console.log("[API_RESPONSE]", {
      url: apiUrl,
      response,
    });

    if (!response?.data) {
      throw new Error("프롬프트를 찾을 수 없습니다.");
    }

    return response.data;
  },

  /**
   * 프롬프트 생성
   */
  async create(data: CreateChatPromptDto): Promise<ChatPromptDto> {
    const apiUrl = `${PREFIX_PATH}/qna-prompt`;

    console.log("[API_CALL]", {
      url: apiUrl,
      method: "POST",
      data,
    });

    const response = await instance.post(apiUrl, data);

    console.log("[API_RESPONSE]", {
      url: apiUrl,
      response,
    });

    if (!response?.data) {
      throw new Error("프롬프트 생성에 실패했습니다.");
    }

    return response.data;
  },

  /**
   * 프롬프트 수정
   */
  async update(id: number, data: UpdateChatPromptDto): Promise<ChatPromptDto> {
    const apiUrl = `${PREFIX_PATH}/qna-prompt/${id}`;

    console.log("[API_CALL]", {
      url: apiUrl,
      method: "PUT",
      id,
      data,
    });

    const response = await instance.put(apiUrl, data);

    console.log("[API_RESPONSE]", {
      url: apiUrl,
      response,
    });

    if (!response?.data) {
      throw new Error("프롬프트 수정에 실패했습니다.");
    }

    return response.data;
  },

  /**
   * 프롬프트 삭제
   */
  async delete(id: number): Promise<void> {
    const apiUrl = `${PREFIX_PATH}/qna-prompt/${id}`;

    console.log("[API_CALL]", {
      url: apiUrl,
      method: "DELETE",
      id,
    });

    const response = await instance.delete(apiUrl);

    console.log("[API_RESPONSE]", {
      url: apiUrl,
      response,
    });
  },

  /**
   * 프롬프트 일괄 수정
   */
  async bulkUpdate(action: string, ids: number[]): Promise<void> {
    const apiUrl = `${PREFIX_PATH}/qna-prompt/bulk-update`;

    console.log("[API_CALL]", {
      url: apiUrl,
      method: "POST",
      action,
      ids,
    });

    const response = await instance.post(apiUrl, { action, ids });

    console.log("[API_RESPONSE]", {
      url: apiUrl,
      response,
    });
  },

  /**
   * AI 모델 제공자 목록 조회
   */
  async getModelProviders(): Promise<string[]> {
    const apiUrl = `${PREFIX_PATH}/qna-prompt/model-providers`;

    console.log("[API_CALL]", {
      url: apiUrl,
      method: "GET",
    });

    const response = await instance.get(apiUrl);

    console.log("[API_RESPONSE]", {
      url: apiUrl,
      response,
    });

    return response?.data || [];
  },

  /**
   * AI 모델명 목록 조회
   */
  async getModelNames(provider?: string): Promise<string[]> {
    const apiUrl = `${PREFIX_PATH}/qna-prompt/model-names`;

    console.log("[API_CALL]", {
      url: apiUrl,
      method: "GET",
      provider,
    });

    const response = await instance.get(apiUrl, {
      params: provider ? { provider } : {},
    });

    console.log("[API_RESPONSE]", {
      url: apiUrl,
      response,
    });

    return response?.data || [];
  },

  /**
   * 프롬프트 통계 조회
   */
  async getStats(): Promise<{
    total: number;
    active: number;
    inactive: number;
    providers: { [key: string]: number };
    models: { [key: string]: number };
  }> {
    const apiUrl = `${PREFIX_PATH}/qna-prompt/stats`;

    console.log("[API_CALL]", {
      url: apiUrl,
      method: "GET",
    });

    const response = await instance.get(apiUrl);

    console.log("[API_RESPONSE]", {
      url: apiUrl,
      response,
    });

    return (
      response?.data || {
        total: 0,
        active: 0,
        inactive: 0,
        providers: {},
        models: {},
      }
    );
  },
};

